import { render, staticRenderFns } from "./Forward copy.vue?vue&type=template&id=2043b405&"
import script from "./Forward copy.vue?vue&type=script&lang=js&"
export * from "./Forward copy.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports